import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';

const VStory = lazy(async () => {
  const { VStory } = await import('../sites/vstory');
  return { default: VStory };
});
const VStoryExample = lazy(async () => {
  const { Example } = await import('../sites/vstory/views/example');
  return { default: Example };
});
const VStoryGuide = lazy(async () => {
  const { Guide } = await import('../sites/vstory/views/guide');
  return { default: Guide };
});
const VStoryDemo = lazy(async () => {
  const { Demo } = await import('../sites/vstory/views/demo');
  return { default: Demo };
});
const VStoryContributing = lazy(async () => {
  const { Contributing } = await import('../sites/vstory/views/contributing');
  return { default: Contributing };
});
const VStoryEntry = lazy(async () => {
  const { Entry } = await import('../sites/vstory/views/entry');
  return { default: Entry };
});

export const vstoryRoutes: RouteObject[] = [
  {
    path: '/vstory',
    element: (
      <Suspense>
        <VStory />
      </Suspense>
    ),
  },
  {
    path: '/vstory/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VStoryExample />
      </Suspense>
    ),
  },
  {
    path: '/vstory/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VStoryGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VStoryGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vstory/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VStoryDemo />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VStoryDemo />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vstory/contributing',
    loader: loaders.contributingLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VStoryContributing />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VStoryContributing />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vstory/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VStoryEntry />
      </Suspense>
    ),
  },
];
